import {ISubmissionProps} from '../../resources/submission';

export const getIndicators = (submissions: ISubmissionProps[]) => {
    return Number((submissions.length / 80 * 100).toFixed(2));
}